"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyTradePwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var VerifyTradePwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VerifyTradePwd, _super);
    function VerifyTradePwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验交易密码';
        _this.code = '101026';
        _this.desc = '校验交易密码';
        _this.requestParams = new password_1.VerifyTradePwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return VerifyTradePwd;
}(service_1.BaseService));
exports.VerifyTradePwd = VerifyTradePwd;
//# sourceMappingURL=verifyTradePwd.js.map